import axios from "axios";
import {API_HOST} from "@/core/variables";


class AuthRepository{
    async me(){
        return axios.get(`${API_HOST}/v1/auth/me`);
    }

    async login(username: string, password: string){
        let form = new FormData();
        form.append('username', username);
        form.append('password',password);
        return axios.post(`${API_HOST}/v1/auth/login`, form);
    }

    async logout(){
        return axios.post(`${API_HOST}/v1/auth/logout`);
    }
} 

const authRepository = new AuthRepository();
export default authRepository;